// Angular
import {Component, OnInit} from '@angular/core';
// Layout
import {LayoutConfigService} from '../../../../core/_base/layout';
// Object-Path
import * as objectPath from 'object-path';
import {HtmlClassService} from '../../html-class.service';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'meu-footer',
  templateUrl: './meu-footer.component.html',
  styleUrls: ['./meu-footer.component.scss'],
})
export class MeuFooterComponent implements OnInit {
  // Public properties
  today: number = Date.now();
  fluid: boolean;
  version = {number: '', detail: ''};

  /**
   * Component constructor
   *
   * @param layoutConfigService: LayouConfigService
   */
  constructor(
    private layoutConfigService: LayoutConfigService,
    public htmlClassService: HtmlClassService,
    private httpClient: HttpClient
  ) {}

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit(): void {
    const config = this.layoutConfigService.getConfig();
    // this.http.get(this.releaseNoteFilePath).subscribe((data) => {
    // });
    // footer width fluid
    this.fluid = objectPath.get(config, 'footer.self.width') === 'fluid';
    this.httpClient
      .get('../../../../../assets/releasenotes/releasenotes.txt', {
        responseType: 'text' as 'json',
      })
      .subscribe((data) => {
        this.version.detail = data.toString();
        this.version.number = this.version.detail.slice(
          0,
          this.version.detail.indexOf(' ')
        );
      });
  }
}
